import { render, staticRenderFns } from "./talentList.vue?vue&type=template&id=21597de0&scoped=true&"
import script from "./talentList.vue?vue&type=script&lang=js&"
export * from "./talentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21597de0",
  null
  
)

export default component.exports